import { get } from '../api';

export const FETCH_CWE_LIST = 'FETCH_CWE_LIST';

const cweActions = {
  fetchCweList: () => ({
    type: FETCH_CWE_LIST,
    async payload() {
      return get(`/api/weaknesses`);
    },
  }),
};

export default cweActions;
